import { Panel } from '@studiometa/ui';

/**
 * PanelInfo component
 */
export default class PanelInfoOutro extends Panel {
  /**
   * Component Configuration
   */
  static config = {
    name: 'PanelInfoOutro',
  };

  scrollDeltaThreshold = -100;
  wheelHandler = null;

  /**
   * Open panel
   */
  async open() {
    super.open();

    this.$el.classList.add('is-open');
    this.scrollDeltaThreshold = 0;
    this.wheelHandler = (event) => this.handleWheel(event);
    window.addEventListener('wheel', this.wheelHandler);
  }

  /**
   * Handle the wheel event.
   * @param {WheelEvent} event The wheel event.
   */
  handleWheel(event) {
    const isAtTop = this.$refs.content.scrollTop === 0;

    if (event.deltaY >= 0 || !isAtTop) {
      this.scrollDeltaThreshold = 0;
      return;
    }

    this.scrollDeltaThreshold += event.deltaY;

    if (this.scrollDeltaThreshold <= -100) {
      this.close();
    }
  }

  /**
   * Close the panel.
   */
  async close() {
    if (this.wheelHandler) {
      window.removeEventListener('wheel', this.wheelHandler);
      this.wheelHandler = null;
    }

    window.scrollTo(0, window.scrollY - 1);

    super.close();
    this.scrollAccumulator = 0;
    this.$el.classList.remove('is-open');
  }
}
